export default {
    canBeStretched: true,
    defaultMobileProperties: {
        textMode: 'noText'
    }
}
